<template>
    <div class="validate-contract px-4 desktop:px-0">
        <div class="text-lg font-bold text-primary-dark-500">
            {{ $t('contract.form-title') }}
        </div>

        <div v-if="showDropinShadow" class="fixed z-20 top-0 left-0 w-screen h-screen" style="background-color: rgba(0,0,0,0.7);" />

        <div class="flex my-4 space-y-4 desktop:space-x-4 desktop:space-y-0 flex-col desktop:flex-row">
            <form :action="action" class="registration-form border border-primary-500 rounded-md shadow-md p-2" method="POST" @submit="onSubmit($event)" ref="form">
                <input type="hidden" name="_token" :value="csrkToken">
                <md-card class="flex flex-col" :class="{'individual' : !!user && !!user.isUserIndividual}">
                    <md-card-content class="col shrink-0 overflow-x-hidden flex-grow">
                        <div v-if="isEntityProfessional" class="text-lg font-bold text-primary-dark-500">
                            {{ $t('contract.general-infos') }}
                        </div>
                        <div v-if="!isEntityProfessional" class="text-lg font-bold text-primary-dark-500">
                            {{ $t('contract.personal-infos') }}
                        </div>
                        <div class="flex flex-col desktop:flex-row flex-wrap">
                            <div class="form-row w-full shrink-0 overflow-x-hidden" :class="{'desktop:w-1/2': isEntityProfessional}">
                                <md-field :class="{'md-invalid': !!errors['user_firstname']}">
                                    <label>{{ $t('registration.firstname') }}</label>
                                    <md-input name="user_firstname" v-model="fData.user_firstname" :disabled="submitting ? 'disabled' : null" autofocus />
                                    <span class="md-error">{{ errors['user_firstname'] ? errors['user_firstname'][0] : '' }}</span>
                                </md-field>
                            </div>
                            <div class="form-row w-full shrink-0 overflow-x-hidden" :class="{'desktop:w-1/2': isEntityProfessional}">
                                <md-field :class="{'md-invalid': !!errors['user_lastname']}">
                                    <label>{{ $t('registration.lastname') }}</label>
                                    <md-input name="user_lastname" v-model="fData.user_lastname" :disabled="submitting ? 'disabled' : null" autofocus />
                                    <span class="md-error">{{ errors['user_lastname'] ? errors['user_lastname'][0] : '' }}</span>
                                </md-field>
                            </div>
                            <div v-if="isEntityProfessional" class="form-row w-full shrink-0 overflow-x-hidden">
                                <md-field :class="{'md-invalid': !!errors['quality']}">
                                    <label>{{ $t('contract.quality') }}</label>
                                    <md-input name="quality" v-model="fData.quality" :disabled="submitting ? 'disabled' : null" required />
                                    <span class="md-error">{{ errors['quality'] ? errors['quality'][0] : '' }}</span>
                                </md-field>
                                <EntityTypeSelector
                                    :field-class="{'md-invalid': !!errors['entity_type_id']}"
                                    :errors="errors['entity_type_id']"
                                    name="entity_type_id"
                                    :disabled="submitting ? 'disabled' : null"
                                    :model="fData.entity_type_id"
                                    @on-change="(value) => fData.entity_type_id = value"
                                    :entity-type-id="parseInt(fData.entity_type_id)"
                                />
                            </div>
                            <div v-if="isEntityProfessional" class="form-row w-full">
                                <!-- <md-field :class="{'md-invalid': !!errors['entity_type']}">
                                    <label>{{ $t('registration.entity-type') }}</label>
                                    <md-select v-model="fData.entity_type" name="entity_type" :disabled="submitting ? 'disabled' : null">
                                        <md-option v-for="entityType in entityTypes" :key="entityType" :value="entityType">
                                            {{ $t('registration.entity-type-' + entityType) }}
                                        </md-option>
                                    </md-select>
                                    <span class="md-error">{{ errors['entity_type'] ? errors['entity_type'][0] : '' }}</span>
                                </md-field> -->
                                <md-autocomplete
                                    ref="sirenAutocomplete"
                                    v-model="fData.entity_name"
                                    :md-options="sirenNameResults"
                                    required
                                    @md-changed="onSirenNameInput"
                                    @md-selected="onSirenSelected"
                                    v-if="fData.entity_country_id == 1"
                                >
                                    <label>{{ $t('registration.entity-name') }}</label>
                                    <template slot="md-autocomplete-item" slot-scope="{ item }">
                                        {{ item.siret }} - {{ item.uniteLegale.denominationUniteLegale }} - {{ item.adresseEtablissement.codePostalEtablissement }} {{ item.adresseEtablissement.libelleCommuneEtablissement }}
                                    </template>
                                    <span class="md-error">{{ errors['entity_siren'] ? errors['entity_siren'][0] : '' }}</span>
                                </md-autocomplete>
                                <md-field v-else :class="{'md-invalid': !!errors['entity_name']}">
                                    <label>{{ $t('registration.entity-name') }}</label>
                                    <md-input name="entity_name" v-model="fData.entity_name" :disabled="submitting ? 'disabled' : null" autofocus />
                                    <span class="md-error">{{ errors['entity_name'] ? errors['entity_name'][0] : '' }}</span>
                                </md-field>
                            </div>
                            <div class="form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden" v-if="isEntityProfessional && showSirenInput">
                                <md-autocomplete
                                    ref="sirenAutocomplete"
                                    v-model="fData.entity_siren"
                                    :md-options="sirenResults"
                                    @md-changed="onSirenInput"
                                    @md-selected="onSirenSelected"
                                    required
                                    v-if="fData.entity_country_id == 1"
                                >
                                    <label>{{ getSirenText }}</label>
                                    <template slot="md-autocomplete-item" slot-scope="{ item }">
                                        {{ item.siret }} - {{ item.uniteLegale.denominationUniteLegale }}
                                    </template>
                                    <span class="md-error">{{ errors['entity_siren'] ? errors['entity_siren'][0] : '' }}</span>
                                </md-autocomplete>
                                <md-field :class="{'md-invalid': !!errors['entity_siren']}" v-else>
                                    <label>{{ getSirenText }}</label>
                                    <md-input type="text" name="entity_siren" v-model="fData.entity_siren" :disabled="submitting ? 'disabled' : null" />
                                    <span class="md-error">{{ errors['entity_siren'] ? errors['entity_siren'][0] : '' }}</span>
                                </md-field>
                            </div>
                            <div v-if="isEntityProfessional" class="form-row w-full shrink-0 desktop:w-1/2">
                                <md-field :class="{'md-invalid': !!errors['intracommunity_vat_number']}">
                                    <label>{{ $t('registration.intracommunity-vat-number') }}</label>
                                    <md-input name="intracommunity_vat_number" v-model="fData.intracommunity_vat_number" :disabled="submitting ? 'disabled' : null" />
                                    <span class="md-error">{{ errors['intracommunity_vat_number'] ? errors['intracommunity_vat_number'][0] : '' }}</span>
                                </md-field>
                            </div>
                            <div class="form-row w-full shrink-0 overflow-x-hidden" :class="{'desktop:w-1/2': isEntityProfessional}">
                                <md-field :class="{'md-invalid': !!errors['entity_address']}">
                                    <label>{{ $t('registration.entity-address') }}</label>
                                    <md-input name="entity_address" v-model="fData.entity_address" :disabled="submitting ? 'disabled' : null" />
                                    <span class="md-error">{{ errors['entity_address'] ? errors['entity_address'][0] : '' }}</span>
                                </md-field>
                            </div>
                            <div class="form-row w-full shrink-0 overflow-x-hidden" :class="{'desktop:w-1/2': isEntityProfessional}">
                                <md-field :class="{'md-invalid': !!errors['entity_postcode']}">
                                    <label>{{ $t('registration.entity-postcode') }}</label>
                                    <md-input name="entity_postcode" v-model="fData.entity_postcode" :disabled="submitting ? 'disabled' : null" autocomplete="shipping postal-code" />
                                    <span class="md-error">{{ errors['entity_postcode'] ? errors['entity_postcode'][0] : '' }}</span>
                                </md-field>
                            </div>
                            <div class="form-row w-full shrink-0 overflow-x-hidden" :class="{'desktop:w-1/2': isEntityProfessional}">
                                <md-field :class="{'md-invalid': !!errors['entity_city']}">
                                    <label>{{ $t('registration.entity-city') }}</label>
                                    <md-input name="entity_city" v-model="fData.entity_city" :disabled="submitting ? 'disabled' : null" />
                                    <span class="md-error">{{ errors['entity_city'] ? errors['entity_city'][0] : '' }}</span>
                                </md-field>
                            </div>
                            <div class="form-row w-full shrink-0 overflow-x-hidden" :class="{'desktop:w-1/2': isEntityProfessional}">
                                <CountrySelector
                                    v-if="fData.entity_country_id"
                                    :field-class="{'md-invalid': !!errors['entity_country_id']}"
                                    :errors="errors['entity_country_id']"
                                    name="entity_country_id"
                                    :disabled="submitting ? 'disabled' : null"
                                    :model="fData.entity_country_id"
                                    @on-change="(value) => fData.entity_country_id = value"
                                    :country-id="parseInt(fData.entity_country_id)"
                                />
                            </div>
                            <template v-if="!isEntityProfessional">
                                <md-datepicker name="user_birthdate" v-model="fData.user_birthdate" :disabled="submitting ? 'disabled' : null" :md-model-type="String">
                                    <label>{{ $t('contract.user-birthdate') }}</label>
                                </md-datepicker>
                                <span class="md-error">{{ errors['user_birthdate'] ? errors['user_birthdate'][0] : '' }}</span>
                            </template>
                            <div v-if="isEntityProfessional" class="form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden">
                                <md-field :class="{'md-invalid': !!errors['accounting_email']}">
                                    <label>{{ $t('registration.accounting-email') }}</label>
                                    <md-input name="accounting_email" v-model="fData.accounting_email" :disabled="submitting ? 'disabled' : null" required />
                                    <span class="md-error">{{ errors['accounting_email'] ? errors['accounting_email'][0] : '' }}</span>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>
                    <md-card-content class="col" v-if="isEntityProfessional">
                        <div class="text-lg font-bold text-primary-dark-500">
                            {{ $t('contract.legal-representative') }}
                        </div>
                        <div class="flex flex-col desktop:flex-row flex-wrap">
                            <div class="form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden">
                                <md-field :class="{'md-invalid': !!errors['legal_representative_firstname']}">
                                    <label>{{ $t('contract.legal-representative-firstname') }}</label>
                                    <md-input type="text" name="legal_representative_firstname" v-model="fData.legal_representative_firstname" :disabled="submitting ? 'disabled' : null" />
                                    <span class="md-error">{{ errors['legal_representative_firstname'] ? errors['legal_representative_firstname'][0] : '' }}</span>
                                </md-field>
                            </div>
                            <div class="form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden">
                                <md-field :class="{'md-invalid': !!errors['legal_representative_lastname']}">
                                    <label>{{ $t('contract.legal-representative-lastname') }}</label>
                                    <md-input type="text" name="legal_representative_lastname" v-model="fData.legal_representative_lastname" :disabled="submitting ? 'disabled' : null" />
                                    <span class="md-error">{{ errors['legal_representative_lastname'] ? errors['legal_representative_lastname'][0] : '' }}</span>
                                </md-field>
                            </div>
                            <div class="form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden">
                                <md-datepicker name="legal_representative_birthdate" v-model="fData.legal_representative_birthdate" :disabled="submitting ? 'disabled' : null" :md-model-type="String">
                                    <label>{{ $t('contract.legal-representative-birthdate') }}</label>
                                </md-datepicker>
                                <span class="md-error">{{ errors['legal_representative_birthdate'] ? errors['legal_representative_birthdate'][0] : '' }}</span>
                            </div>
                            <div class="form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden">
                                <CountrySelector
                                    :field-class="{'md-invalid': !!errors['legal_representative_country_id']}"
                                    :errors="errors['legal_representative_country_id']"
                                    name="legal_representative_country_id"
                                    :disabled="submitting ? 'disabled' : null"
                                    :model="fData.legal_representative_country_id"
                                    @on-change="(value) => fData.legal_representative_country_id = value"
                                    :country-id="parseInt(fData.legal_representative_country_id)"
                                    :label="$t('contract.legal-representative-country')"
                                />
                            </div>
                            <div class="form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden">
                                <CountrySelector
                                    :field-class="{'md-invalid': !!errors['legal_representative_birth_country_id']}"
                                    :errors="errors['legal_representative_birth_country_id']"
                                    name="legal_representative_birth_country_id"
                                    :disabled="submitting ? 'disabled' : null"
                                    :model="fData.legal_representative_birth_country_id"
                                   
                                    @on-change="(value) => fData.legal_representative_birth_country_id = value"
                                    :country-id="parseInt(fData.legal_representative_birth_country_id)"
                                    :label="$t('contract.legal-representative-birth-country')"
                                />
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </form>

            <div class="border border-primary-500 rounded-md shadow-md p-6" v-if="!!price" style="max-width: 600px;">
                <div class="contract-price-info">
                    <div class="contract-price-name">
                        <strong>{{ price.name }}</strong>
                        <span class="contract-price-free" v-if="!!fData.promoCode && fData.promoCode.free_months">
                            {{ $t('contract.free-months', { count: fData.promoCode.free_months }, fData.promoCode.free_months) }}
                        </span>
                    </div>
                    <div class="flex justify-end">
                        <div class="contract-price-amount">
                            <div class="promoPrice" v-if="fData.promoCode && (!!fData.promoCode.price || !!fData.promoCode.percentage)">
                                {{ getPricePromoPrice }}
                            </div>
                            {{ getPrice }} *
                        </div>
                    </div>
                    <div class="contract-price-promo-code">
                        <div class="text">
                            {{ $t('contract.promo-code') }}
                        </div>
                        <div class="input" v-if="!fData.promoCode">
                            <input type="text" v-model="promoCodeInput">
                        </div>
                        <div class="input valid" v-else>
                            <span>{{ promoCodeInput }}</span>
                            <i class="md-icon md-icon-font md-theme-default">
                                check
                            </i>
                        </div>
                        <div class="button" v-if="!fData.promoCode">
                            <button @click="checkPromoCode" :disabled="!promoCodeInput || promoCodeInput.length == 0">
                                {{ $t('contract.apply') }}
                            </button>
                        </div>
                    </div>
                    <span class="md-error text-right" v-if="!!errors['promoCode']">
                        {{ $t('contract.invalid-promo-code') }} 
                    </span>
                    <div class="contract-price-promo-code mt-2">
                        <div class="text">
                            {{ $t('contract.sponsor-code') }}
                        </div>
                        <div class="input" v-if="!fData.sponsor">
                            <input type="text" name="sponsor" v-model="sponsorInput" :disabled="submitting ? 'disabled' : null">
                        </div>
                        <div class="input valid" v-else>
                            <span>{{ fData.sponsor }}</span>
                            <i class="md-icon md-icon-font md-theme-default">
                                check
                            </i>
                        </div>
                        <div class="button" v-if="!fData.sponsor">
                            <button @click="checkSponsor" :disabled="!sponsorInput || sponsorInput.length == 0">
                                {{ $t('contract.apply') }}
                            </button>
                        </div>
                    </div>
                    <span class="md-error text-right" v-if="!!errors['sponsor']">
                        {{ $t('contract.invalid-sponsor-code') }} 
                    </span>
                    <div class="text-xs my-4">
                        {{ $t('contract.recurrence-footnote' + (isEntityProfessional ? '' : '-individual'), {months: periodDurationIncludePromo, recurringPrice: isEntityProfessional ? price.recurring_price_ht : price.recurring_price_ttc}) }}
                    </div>
                    <div class="text-lg font-bold text-primary-dark-500 mt-10">
                        {{ $t('contract.payment') }}
                    </div>
                    <div class="form-row">
                        <CountrySelector
                            :field-class="{'md-invalid': !!errors['bank_country_id']}"
                            :errors="errors['bank_country_id']"
                            name="bank_country_id"
                            :disabled="submitting ? 'disabled' : null"
                            :model="fData.bank_country_id"
                            @on-change="(value) => fData.bank_country_id = value"
                            :country-id="parseInt(fData.bank_country_id)"
                            :label="$t('contract.bank-country')"
                        />
                    </div>
                    <template v-if="showGoCardlessPayment">
                        <div class="text-primary-dark-500 my-4">
                            {{ $t('contract.payment-info') }}
                        </div>
                        <template v-if="!!selectedBankCountry">
                            <div class="form-row" v-if="selectedBankCountry.isoCode != 'GB'">
                                <md-field class="iban" :class="{'md-invalid': !!errors['entity_iban']}">
                                    <label>{{ $t('contract.iban') }}</label>
                                    <md-input v-mask="'XXXX XXXX XXXX XXXX XXXX XXXX XXX'" name="entity_iban" v-model="fData.entity_iban" :disabled="submitting ? 'disabled' : null" />
                                    <span class="md-error">{{ errors['entity_iban'] ? errors['entity_iban'][0] : '' }}</span>
                                </md-field>
                            </div>
                            <template v-else>
                                <div class="form-row">
                                    <md-field class="branch_code" :class="{'md-invalid': !!errors['entity_branch_code']}">
                                        <label>{{ $t('contract.branch-code') }}</label>
                                        <md-input v-mask="'XXXXXX'" name="entity_branch_code" v-model="fData.entity_branch_code" :disabled="submitting ? 'disabled' : null" />
                                        <span class="md-error">{{ errors['entity_branch_code'] ? errors['entity_branch_code'][0] : '' }}</span>
                                    </md-field>
                                </div>
                                <div class="form-row">
                                    <md-field class="account_number" :class="{'md-invalid': !!errors['entity_account_number']}">
                                        <label>{{ $t('contract.account-number') }}</label>
                                        <md-input v-mask="'XXXXXXXX'" name="entity_account_number" v-model="fData.entity_account_number" :disabled="submitting ? 'disabled' : null" />
                                        <span class="md-error">{{ errors['entity_account_number'] ? errors['entity_account_number'][0] : '' }}</span>
                                    </md-field>
                                </div>
                            </template>
                        </template>
                        <div class="form-row">
                            <md-field class="account_holder_name" :class="{'md-invalid': !!errors['account_holder_name']}">
                                <label>{{ $t('contract.account-holder-name') }}</label>
                                <md-input name="account_holder_name" v-model="fData.account_holder_name" :disabled="submitting ? 'disabled' : null" />
                                <span class="md-error">{{ errors['account_holder_name'] ? errors['account_holder_name'][0] : '' }}</span>
                            </md-field>
                        </div>
                    </template>
                    <div v-if="showStripePayment" class="my-4">
                        <p class="text-primary-dark-500 my-4">{{ $t('contract.card-payment-info') }}</p>
                        <div id="link-authentication-element">
                            <!-- Elements will create authentication element here -->
                        </div>
                        <div id="payment-element" ref="paymentElement">
                            <!-- Elements will create form elements here -->
                        </div>
                        <span class="md-error" v-if="!!stripeCardError">{{ stripeCardError }}</span>
                        <div class="my-4 text-primary-dark-500" v-if="!!stripeTrialPrice">
                            {{ $t('contract.total-price', {price: $pu(stripeTrialPrice)}) }}
                        </div>
                    </div>
                    <label class="flex space-x-2 mt-2 items-start">
                        <input type="checkbox" v-model="acceptTos" dusk="acceptTos" class="mt-1">
                        <div v-html="$t('contract.tos')" />
                    </label>
                    <label class="flex space-x-2 mt-2" v-if="!isEntityProfessional">
                        <input type="checkbox" v-model="acceptPayment">
                        <div v-html="$t('contract.accept-payment')" />
                    </label>
                    <div class="text-red-500 font-semibold mt-2" v-if="ibanError">
                        {{ ibanError }}
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end">
            <submit-button
                type="submit"
                :submitting="submitting"
                :label="$t('contract.validate-contract')"
                @click="onSubmit()"
                dusk="submit-profile-button"
                :disabled="!canSubmit"
                class="px-4 mb-4"
            />
        </div>
        
        <md-dialog :md-active.sync="showSmsDialog">
            <div class="flex flex-col justify-center h-screen items-center desktop:h-auto">
                <div class="sms-dialog" v-if="!submitting">
                    <div class="form-row" v-if="showPhoneInput">
                        <phone-field
                            name="phone"
                            v-model="fData.phone"
                            :errors="errors['phone']"
                            :label="$t('contract.phone')"
                            :country-id="countryId"
                            ref="phoneInput"
                            mobile-only
                            :disabled="submitting ? 'disabled' : null"
                        />
                        <submit-button
                            type="submit"
                            class="registration-standalone-button"
                            :submitting="sendingCode"
                            label="Recevoir le code par SMS"
                            @click="sendCode"
                            :disabled="!isValidMobilePhone"
                        />
                    </div>
                    <div class="form-row" v-if="!showPhoneInput">
                        {{ $t('contract.code-sent-helper', {
                            phone: fData.phone
                        }) }}
                        <form>
                            <md-field :class="{'md-invalid': !!errors['code'], 'code-field': true}">
                                <md-input style="display:none" type="text" name="code" v-model="fData.code" :disabled="submitting ? 'disabled' : null" />
                                <div class="SMS__Code" ref="smsCodeInputs">
                                    <input type="number" inputmode="tel" v-model="SMSCode.input1" id="smsCodeInput0" class="SMS__Code__Input" @input="focusNextSMSCodeInput" ref="firstInput">
                                    <input type="number" inputmode="tel" v-model="SMSCode.input2" id="smsCodeInput1" class="SMS__Code__Input" @input="focusNextSMSCodeInput">
                                    <input type="number" inputmode="tel" v-model="SMSCode.input3" id="smsCodeInput2" class="SMS__Code__Input" @input="focusNextSMSCodeInput">
                                    <input type="number" inputmode="tel" v-model="SMSCode.input4" id="smsCodeInput3" class="SMS__Code__Input" @input="focusNextSMSCodeInput">
                                </div>
                                <span class="md-helper-text">
                                    <a role="button" class="pointer" @click="active = true">{{ $t('contract.resend-code-confirm-title') }}</a>
                                </span>
                                <span class="md-error">
                                    {{ errors['code'] ? errors['code'][0] : '' }} 
                                    <a role="button" class="pointer" @click="active = true">{{ $t('contract.resend-code-confirm-title') }}</a>
                                </span>
                            </md-field>
                        </form>
                    </div>
                </div>
                <div v-else>
                    <div class="flex flex-col justify-center items-center">
                        <md-spinner />
                        <div class="text-primary-dark-500 mt-4">
                            {{ $t('contract.signing') }}
                        </div>
                    </div>
                </div>
            </div>
        </md-dialog>
        <md-dialog-confirm
            :md-active.sync="active"
            :md-title="$t('contract.resend-code-confirm-title')"
            :md-content="$t('contract.resend-code-confirm-desc', {number: fData.phone})"
            :md-confirm-text="$t('contract.resend-code-confirm-title')"
            :md-cancel-text="$t('contract.cancel')"
            @md-confirm="onConfirm"
        />
        <md-dialog :md-active.sync="showPaymentConfirmation">
            <div class="p-8 text-primary-dark-500 payment-confirmation-dialog overflow-y-auto pt-20 desktop:pt-8">
                <div class="flex justify-between items-center mb-8 space-x-8">
                    <h3 class="font-bold text-lg">
                        {{ $t('contract.sepa-mandate' + (isEntityProfessional ? '' : '-individual')) }}
                    </h3>
                    <img src="/imgs/icons/sepa.svg" class="w-24">
                </div>
                <div class="uppercase font-bold">
                    {{ $t('contract.debit-request') }}
                </div>
                <div class="my-4">
                    {{ $t('contract.debit-request-validity') }}
                </div>
                <div class="flex desktop:space-x-4 flex-col desktop:flex-row">
                    <div class="w-full desktop:w-1/2 border p-4">
                        <div class="font-bold mb-4">
                            {{ $t('contract.account-to-debit') }}
                        </div>
                        <div class="flex flex-col desktop:flex-row justify-start my-2 whitespace-nowrap shrink-0 desktop:items-center">
                            <div class="font-bold mr-4">
                                {{ $t('contract.bank-country') }}
                            </div>
                            <div v-if="!!selectedBankCountry" class="whitespace-normal">
                                {{ selectedBankCountry.name }}
                            </div>
                        </div>
                        <div class="flex flex-col desktop:flex-row justify-start my-2 whitespace-nowrap shrink-0 desktop:items-center">
                            <div class="font-bold mr-4">
                                {{ $t('contract.iban') }}
                            </div>
                            <div class="whitespace-normal">
                                {{ fData.entity_iban }}
                            </div>
                        </div>
                        <div class="flex flex-col desktop:flex-row justify-start my-2 whitespace-nowrap shrink-0 desktop:items-center">
                            <div class="font-bold mr-4">
                                {{ $t('contract.account-holder-name') }}
                            </div>
                            <div class="whitespace-normal">
                                {{ fData.account_holder_name }}
                            </div>
                        </div>
                    </div>
                    <div class="w-full desktop:w-1/2 border p-4 mt-4 desktop:mt-0">
                        <div class="font-bold mb-4">
                            {{ $t('contract.creditor') }}
                        </div>
                        <div class="flex flex-col desktop:flex-row justify-start my-2 whitespace-nowrap shrink-0 desktop:items-center">
                            <div class="font-bold mr-4">
                                OpenFly
                            </div>
                        </div>
                        <div class="flex flex-col desktop:flex-row justify-start my-2 whitespace-nowrap shrink-0 desktop:items-center">
                            <div class="font-bold mr-4">
                                {{ $t('contract.sepa-identifier') }}
                            </div>
                            <div class="whitespace-normal">
                                FR26ZZZ8231EE
                            </div>
                        </div>
                    </div>
                </div>
                <p class="text-xs mt-4">{{ $t('contract.signature-info' + (isEntityProfessional ? '' : '-individual')) }}</p>
                <p class="font-bold mt-8 mb-4">{{ $t('contract.first-fee') }}</p>
                <div class="flex justify-between items-center flex-col desktop:flex-row">
                    <div id="paymentConfirmationCompliance" ref="paymentConfirmationCompliance" />
                    <div class="flex justify-end items-center mt-4 desktop:mt-0">
                        <a class="!text-gray-700 !text-xs cursor-pointer !underline mr-4" @click="showPaymentConfirmation = false">{{ $t('global.cancel') }}</a>
                        <submit-button class="!text-white" :label="$t('contract.confirm-payment')" @click="confirmPayment" dusk="confirmPaymentButton" :submitting="submittingPayment" />
                    </div>
                </div>
            </div>
        </md-dialog>
        <md-dialog :md-active.sync="showSelectInstitutionModal" :md-click-outside-to-close="false" :md-close-on-esc="false">
            <div class="p-4 select-institution-modal">
                <h3 class="font-bold text-lg mb-4">
                    {{ $t('contract.select-institution') }}
                </h3>
                <div class="form-row">
                    <md-field :class="{'md-invalid': !!errors['bank_institution_id']}">
                        <label>
                            {{ $t('contract.bank') }}
                        </label>

                        <md-select
                            v-model="fData.bank_institution_id"
                            name="bank_institution_id"
                        >
                            <md-option
                                v-for="institution in bankInstitutions"
                                :key="institution.id"
                                :value="institution.id"
                            >
                                {{ institution.name }}
                            </md-option>
                        </md-select>

                        <span class="md-error">
                            {{ errors['bank_institution_id'] && errors['bank_institution_id'].length ? errors['bank_institution_id'][0] : '' }}
                        </span>
                    </md-field>
                </div>
                <div class="flex justify-end items-center">
                    <a class="!text-gray-700 !text-xs cursor-pointer" @click="showSelectInstitutionModal = false">{{ $t('global.cancel') }}</a>
                    <submit-button class="!text-white" :label="$t('contract.confirm-payment')" @click="setInstitution" dusk="setInstitutionButton" />
                </div>
            </div>
        </md-dialog>
    </div>
</template>

<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import * as _ from 'lodash';
import * as moment from 'moment';
import { mask } from 'vue-the-mask';
import CountrySelector from './CountrySelector.vue';
import EntityTypeSelector from './EntityTypeSelector.vue';
import PhoneField from './widgets/PhoneFieldComponent.vue';

export default {
    components: {
        PhoneField,
        CountrySelector,
        EntityTypeSelector,
    },
    directives: {
        mask
    },
    props: {
        action: String,
        smsAction: String,
        promoCodeAction: String,
        regenerateAction: String,
        formData: String,
        mediaUrl: String,
        countryId: String,
        countryCode: String,
        generate: {
            type: Boolean,
            default: false
        },
        currentUser: String,
        contractPrice: String,
        // entityTypesString: {
        //     type    : String,
        //     required: true,
        // },
        contractId: Number,
        gocardlessSandbox: {
            type: Boolean,
            default: true,
        },
        stripeKey: String,
    },
    data() {
        return {
            active: false,
            isEntityProfessional: true,
            showPhoneInput: true,
            showSirenInput: true,
            acceptTos: false,
            acceptPayment: false,
            fData: {
                entity_iban: '',
                account_holder_name: '',
                entity_siren: '',
                legal_representative_firstname: '',
                legal_representative_lastname: '',
                legal_representative_birthdate: '',
                user_birthdate: '',
                legal_representative_country_id: '',
                legal_representative_birth_country_id: '',
                phone: '',
                code: '',
                sponsor: '',
                entity_name: '',
                entity_address: '',
                entity_postcode: '',
                entity_city: '',
                entity_country_id: '',
                entity_type_id: '',
                accounting_email: '',
                quality: '',
                entity_legal: '',
                // entity_type: 'company',
                promoCode: null,
                sponsor: null,
                price: JSON.parse(this.contractPrice).id,
                bank_country_id: '',
                bank_institution_id: null,
                entity_branch_code: '',
                entity_account_number: '',
                user_firstname: '',
                user_lastname: '',
                force_stripe_subscription: 0,
                ape_code: '',
                intracommunity_vat_number: '',
            },
            errors: {
                entity_iban: null,
                // entity_bic: null,
                account_holder_name: null,
                phone: null,
                sponsor: null,
                entity_siren: null,
                legal_representative_firstname: null,
                legal_representative_lastname: null,
                legal_representative_birthdate: null,
                user_birthdate: null,
                legal_representative_country_id: null,
                legal_representative_birth_country_id: null,
                entity_name: null,
                entity_address: null,
                entity_postcode: null,
                entity_city: null,
                entity_country_id: null,
                entity_type_id: null,
                accounting_email: null,
                quality: null,
                // entity_type: null,
                code: null,
                promoCode: null,
                sponsor: null,
                bank_country_id: null,
                bank_institution_id: null,
                entity_branch_code: null,
                entity_account_number: null,
                intracommunity_vat_number: null,
            },
            csrkToken: Laravel.csrfToken,
            submitting: false,
            sendingCode: false,
            codeSent: false,
            price: null,
            user: null,
            promoCodeInput: null,
            sponsorInput: null,
            currency: 'EUR',
            showSmsDialog: false,
            SMSCode: {},
            bankInstitutions: [],
            countries: [],
            showPaymentConfirmation: false,
            showDropinShadow: false,
            showSelectInstitutionModal: false,
            billingRequestId: null,
            submittingPayment: false,
            stripe: Stripe(this.stripeKey),
            stripeCardError: null,
            ibanError: false,
            stripeTrialPrice: null,
            sirenResults: [],
            sirenNameResults: [],
        };
    },
    computed: {
        isValidMobilePhone() {
            if (this.fData.phone) {
                let parsedNumber = parsePhoneNumberFromString(this.fData.phone, this.countryCode);
                if (parsedNumber) {
                    return parsedNumber.getType() === 'MOBILE';
                }
            }
            return false;
        },
        canSubmit() {
            if (this.submitting) {
                return false;
            }
            if (!this.acceptTos) {
                return false;
            }
            if (!this.isEntityProfessional && !this.acceptPayment) {
                return false;
            }
            if (this.isEntityProfessional) {
                return this.fData.entity_siren != '' &&
                    this.fData.phone != '' &&
                    this.fData.quality != '' &&
                    this.fData.quality != null &&
                    this.fData.entity_name != '' &&
                    this.fData.entity_address != '' &&
                    this.fData.entity_postcode != '' &&
                    this.fData.entity_city != '' &&
                    this.fData.entity_country_id != '';
            } else {

                return this.fData.entity_address != '' &&
                    this.fData.entity_postcode != '' &&
                    this.fData.entity_city != '' &&
                    this.fData.user_birthdate != '';
            }
        },
        getSirenText () {
            if (location.host.includes('.ch')) {
                return this.$t('contract.duns');
            }
            return this.$t('contract.siren');
        },
        userPrice() {
            var price = this.user.isUserIndividual ? this.price.trial_period_price_ttc : this.price.trial_period_price_ht;
            if (!!this.fData.promoCode) {
                if (!!this.fData.promoCode.price) {
                    return price - this.fData.promoCode.price;
                } else {
                    return price * (1 - (this.fData.promoCode.percentage / 100));
                }
            }
            return price;
        },
        priceWithVat() {
            var price = this.price.trial_period_price_ttc;
            if (!!this.fData.promoCode) {
                if (!!this.fData.promoCode.price) {
                    if (this.user.isUserIndividual) {
                        return this.price.trial_period_price_ttc - this.fData.promoCode.price;
                    } else {
                        return 1.2 * (this.price.trial_period_price_ht - this.fData.promoCode.price);
                    }
                } else {
                    return price * (1 - (this.fData.promoCode.percentage / 100));
                }
            }
            return price;
        },
        getPrice() {
            const vatKey = this.user.isUserIndividual
                ? 'with'
                : 'without';
            return this.$t(`global.price-${vatKey}-taxes`, {
                price: this.$pu(this.userPrice),
            });
        },
        getPricePromoPrice() {
            if (!this.fData.promoCode) {
                return 0;
            }
            var price = this.user.isUserIndividual ? this.price.trial_period_price_ttc : this.price.trial_period_price_ht;
            const vatKey = this.user.isUserIndividual
                ? 'with'
                : 'without';
            return this.$t(`global.price-${vatKey}-taxes`, {
                price: this.$pu(price),
            });
        },
        selectedBankCountry() {
            return this.countries.find((c) => c.id == this.fData.bank_country_id);
        },
        selectedBankInstitution() {
            return this.bankInstitutions.find((b) => b.id == this.fData.bank_institution_id);
        },
        showGoCardlessPayment() {
            return this.fData.force_stripe_subscription == 0 && this.fData.bank_country_id && (this.fData.bank_country_id == 1 || this.fData.bank_country_id == 6 || this.fData.bank_country_id == 57);
        },
        showStripePayment() {
            return this.fData.force_stripe_subscription == 1 || (this.fData.bank_country_id && this.fData.bank_country_id != 1 && this.fData.bank_country_id != 6 && this.fData.bank_country_id != 57);
        },
        periodDurationIncludePromo() {
            if (!!this.fData.promoCode) {
                return this.price.trial_period_duration_months + this.fData.promoCode.free_months;
            } else {
                return this.price.trial_period_duration_months;
            }
        },
    },
    watch: {
        'fData.password': function(value) {
            this.errors['password'] = null;
        },
        'fData.entity_iban': function(value) {
            this.errors['entity_iban'] = null;
        },
        'fData.entity_branch_code': function(value) {
            this.errors['entity_branch_code'] = null;
        },
        'fData.entity_account_number': function(value) {
            this.errors['entity_account_number'] = null;
        },
        'fData.quality': function(value) {
            this.errors['quality'] = null;
        },
        'fData.intracommunity_vat_number': function(value) {
            this.errors['intracommunity_vat_number'] = null;
        },
        // 'fData.entity_bic': function(value) {
        //     this.errors['entity_bic'] = null;
        // },
        'fData.account_holder_name': function(value) {
            this.errors['account_holder_name'] = null;
        },
        // 'fData.entity_type': function(value) {
        //     this.errors['entity_type'] = null;
        // },
        'fData.password_confirmation': function(value) {
            this.errors['password_confirmation'] = null;
        },
        'fData.phone': function(value) {
            this.errors['phone'] = null;
        },
        'fData.role': function(value) {
            this.errors['role'] = null;
        },
        'fData.promoCode': async function(value, oldValue) {
            if (this.showStripePayment && value != oldValue) {
                this.updateStripePaymentIntent();
            }
        },
        'fData.bank_country_id': async function(value, oldValue) {
            if (this.showStripePayment && value != oldValue) {
                this.updateStripePaymentIntent();
            }
        },
        'fData.entity_country_id': async function(value, oldValue) {
            if (this.showStripePayment && value != oldValue) {
                this.updateStripePaymentIntent();
            }
        },
        showSmsDialog(newValue, oldValue) {
            if (newValue && !oldValue) {
                this.$waitForRef('smsCodeInputs').then(() => {
                    Array.from(this.$refs.smsCodeInputs.querySelectorAll('input[class="SMS__Code__Input"]'))[0].focus();
                });
            }
        },
        showPaymentConfirmation(value) {
            if (!value) {
                this.submitting = false;
            }
        },
    },
    created() {
        axios.get('/api/countries').then((response) => {
            this.countries = response.data;
        });
    },
    mounted() {
        this.price = JSON.parse(this.contractPrice);
        this.user = JSON.parse(this.currentUser);
        const formDataObj = JSON.parse(this.formData);

        if (!!formDataObj.entity_legal && formDataObj.entity_legal != 'professional') {
            this.isEntityProfessional = false;
        }
        for (var i of Object.keys(formDataObj)) {
            console.log(i);
            if (i == 'entity_name' && this.isEntityProfessional && formDataObj.entity_country_id == 1) {
                // use a siren to get the name
                this.fData[i] =  null;
            } else {
                this.fData[i] = formDataObj[i];
            }
        }

        const urlParams = new URLSearchParams(window.location.search);
        if (!(this.fData.sponsor || '').trim().length && urlParams.get('sponsor')) {
            this.fData.sponsor = urlParams.get('sponsor');
        }

        // if (this.fData.entity_siren && this.fData.entity_siren.length > 8) {
        //     this.showSirenInput = false;
        // }

        this.resetSMSCodeForm();
    },
    methods: {
        sendCode() {
            this.sendingCode = true;
            $.post(this.smsAction, {
                phone: this.fData.phone
            }, response => {
                this.sendingCode = false;
                this.showPhoneInput = false;
            }).fail(error => {
                this.sendingCode = false;
                for (var i of Object.keys(this.errors)) {
                    this.errors[i] = error.responseJSON['errors'][i];
                }
            });
        },
        checkPromoCode() {
            $.post(this.promoCodeAction, {
                promoCode: this.promoCodeInput
            }, response => {
                this.fData.promoCode = response;
                this.errors['promoCode'] = null;
            }).fail(error => {
                this.errors['promoCode'] = error.responseJSON['message'];
            });
        },
        checkSponsor() {},
        onSubmit(event) {
            this.submitting = true;
            for (var i of Object.keys(this.errors)) {
                this.errors[i] = null;
            }
            if (event) {
                event.preventDefault();
            }

            this.submit(true).then((valid) => {
                this.submitting = false;
                if (valid) {
                    if (this.isValidMobilePhone) {
                        this.showPhoneInput = false;
                        this.sendCode();
                    }
                    this.showSmsDialog = true;
                }
            });
        },
        onConfirm () {
            this.sendCode();
        },
        onCancel () {
            //
        },
        $p(_p, _c, _r, fn, _d) {
            let price, currency, rate, digits;
            if (_p === null) {
                price = 0;
                currency = _c || 'EUR';
                rate = _r || 1;
            } else if (typeof _p === 'object') {
                price = _p.value;
                currency = _p.currency.code;
                rate = _p.currency.rate;
            } else {
                price = _p;
                currency = _c || 'EUR';
                rate = _r || 1;
            }
            fn = fn || Math.ceil;
            digits = _d || 0;
            
            const ratePrice = digits ? (price * rate).toFixed(digits): fn(price * rate);
            return new Intl.NumberFormat(this.$i18n.locale(), { style: 'currency', currency, minimumFractionDigits: digits }).format(ratePrice);
        },

        $pu(_p, _c, _r, fn, _d) {
            if (!_c &&
                !!this.currentUser &&
                !!this.currentUser.currency
            ) {
                _c = this.currentUser.currency.code;
                _r = this.currentUser.currency.rate;
            }
            return this.$p(_p, _c, _r, fn, _d);
        },
        focusNextSMSCodeInput(e) {
            this.errorMessage = null;
            this.newCodeSent = false;
            const inputs = Array.from(e.target.form.querySelectorAll('input[class="SMS__Code__Input"]'));
            let index = inputs.indexOf(e.target);

            if (e.target.value) {
                if (index == 0 && e.target.value.length == 4) { // when pasting the received code on iOS
                    const chars = String(e.target.value).split('');
                    chars.forEach((char, idx) => {
                        this.SMSCode['input' + (idx + 1)] = char;
                    });
                } else {
                    if (index < inputs.length - 1) {
                        inputs[index + 1].focus();
                    } else {
                        //this.submit();
                    }
                }
            }
            this.fData.code = _.values(this.SMSCode).join('');
            if (this.fData.code.length == 4) {
                this.submit();
            }
        },
        async submit(validation = false) {
            this.submitting = true;
            var formData = new FormData();
            Object.entries(this.fData).forEach((element) => {
                if (!!element[1]) {
                    if (element[0] == 'user_birthdate' || element[0] == 'legal_representative_birthdate') {
                        formData.append(element[0], moment(element[1], this.$t('global.vue-material-date-format-moment')).format('Y-MM-DD'));
                    } else if (element[0] == 'promoCode') {
                        formData.append(element[0], JSON.stringify(element[1]));
                    } else {
                        formData.append(element[0], element[1]);
                    }
                }
            });
            if (this.showStripePayment) {
                if (validation) {
                    formData.append('stripe_payment', 1);
                } else {
                    this.stripeCardError = null;
                    const {error, paymentIntent} = await this.stripe.confirmPayment({
                        //`Elements` instance that was used to create the Payment Element
                        elements: this.elements,
                        redirect: 'if_required',
                        confirmParams: {
                            payment_method_data: {
                                billing_details: {
                                    address: {
                                        country: this.selectedBankCountry.isoCode,
                                    },
                                },
                            },
                        }
                    });
                    if (!!error) {
                        this.submitting = false;
                        this.showSmsDialog = false;
                        this.stripeCardError = error.message;
                        this.fData.code = '';
                        return;
                    } else {
                        formData.append('stripe_payment_intent_id', paymentIntent.id);
                    }
                }
            }
            if (validation) {
                formData.append('validation', 1);
            }
            return axios.post(this.action, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if (validation) {
                    return true;
                } else {
                    this.onPaymentResponse(response);
                }
            }).catch((error) => {
                this.submitting = false;
                this.resetSMSCodeForm();
                for (var i of Object.keys(this.errors)) {
                    this.errors[i] = error.response.data.errors[i];
                }
                if (!this.errors['code']) {
                    this.showSmsDialog = false;
                }
                if (validation) {
                    return false;
                }
            });
        },
        resetSMSCodeForm() {
            this.SMSCode = {
                input1: null,
                input2: null,
                input3: null,
                input4: null,
            };
        },
        checkPaymentStatus() {
            axios.get('/api/entity-contract/' + this.contractId + '/payment-status').then((response) => {
                if (response.data == 'submitted' || response.data == 'confirmed' || response.data == 'pending_submission' || response.data == 'succeeded') {
                    axios.post('/api/entity-contract/' + this.contractId + '/finalize-sign').then((response) => {
                        if (!!response.data['redirect']) {
                            window.location = response.data['redirect'];
                        } else {
                            this.submitting = false;
                            this.submittingPayment = false;
                            this.showPaymentConfirmation = false;
                        }
                    }).catch((error) => {
                        this.submitting = false;
                        this.submittingPayment = false;
                        this.showPaymentConfirmation = false;
                    });
                } else {
                    this.submitting = false;
                    this.submittingPayment = false;
                    this.showPaymentConfirmation = false;
                }
            });
        },
        loadBankInstitutions(billingRequestId) {
            axios.get('/api/gocardless/institutions/' + billingRequestId)
                .then((response) => {
                    this.bankInstitutions = response.data;
                });
        },
        confirmPayment() {
            this.submittingPayment = true;
            this.$nextTick(() => {
                this.submitting = true;
                var formData = new FormData();
                Object.entries(this.fData).forEach((element) => {
                    if (!!element[1]) {
                        if (element[0] == 'user_birthdate' || element[0] == 'legal_representative_birthdate') {
                            formData.append(element[0], moment(element[1], this.$t('global.vue-material-date-format-moment')).format('Y-MM-DD'));
                        } else if (element[0] == 'promoCode') {
                            formData.append(element[0], JSON.stringify(element[1]));
                        } else {
                            formData.append(element[0], element[1]);
                        }
                    }
                });
                axios.post('/api/entity-contract/' + this.contractId + '/fulfil-billing-request', formData).then(() => {
                    this.checkPaymentStatus();
                }).catch((error) => {
                    this.ibanError =  error.response.data.message;
                    this.submitting = false;
                    this.submittingPayment = false;
                    this.showPaymentConfirmation = false;
                });
            });
        },
        setInstitution() {
            this.showSelectInstitutionModal = false;
            axios.post('/api/entity-contract/' + this.contractId + '/select-institution', {bank_institution_id: this.fData.bank_institution_id}).then((response) => {
                this.onPaymentResponse(response);
            });
        },
        onPaymentResponse(response) {
            if (!!response.data['redirect']) {
                window.location = response.data['redirect'];
            } else if (!!response.data['stripe']) {
                this.checkPaymentStatus();
            } else if (!!response.data['finalize']) {
                this.showSmsDialog = false;
                this.resetSMSCodeForm();
                this.showPaymentConfirmation = true;
                this.$waitForRef('paymentConfirmationCompliance').then(() => {
                    window.GoCardlessCompliance.render(
                        response.data['billingRequestId'],
                        'bank-authorisation',
                        {parentId: 'paymentConfirmationCompliance'}
                    );
                });
            } else if (!!response.data['mustSelectInstitution']) {
                this.showSmsDialog = false;
                this.resetSMSCodeForm();
                this.showDropinShadow = true;
                this.bankInstitutions = response.data['institutions'];
                this.billingRequestId = response.data['billingRequestId'];
                this.showSelectInstitutionModal = true;
            } else if (!!response.data['billingRequestFlowId']) {
                const handler = GoCardlessDropin.create({
                    billingRequestFlowID: response.data['billingRequestFlowId'],
                    environment: this.gocardlessSandbox ? 'sandbox' : 'live', // either live or sandbox
                    onSuccess: (billingRequest, billingRequestFlow) => {
                        handler.exit();
                        this.checkPaymentStatus();
                        this.showDropinShadow = false;
                    },
                    onExit: (error, metadata) => {
                        handler.exit();
                        this.checkPaymentStatus();
                        this.showDropinShadow = false;
                    },
                });
                handler.open();
            } else {
                this.submitting = false;
                this.showSmsDialog = false;
                this.resetSMSCodeForm();
            }
        },
        async updateStripePaymentIntent() {
            if (!!this.paymentElement) {
                this.stripeTrialPrice = null;
                this.paymentElement.unmount();
            }
            const subscriptionData = (await axios.post('/api/create-stripe-payment-intent', {
                entity_contract_id: this.contractId,
                promo_code_id: !!this.fData.promoCode ? this.fData.promoCode.id : null,
                entity_country_id: this.fData.entity_country_id,
            })).data;
            this.stripeTrialPrice = subscriptionData.trialPrice;
            this.elements = this.stripe.elements({
                fonts: [
                    {
                        cssSrc: 'https://fonts.googleapis.com/css?family=Spartan:300,400,600&display=swap'
                    },
                ],
                locale: window.appLocale,
                clientSecret: subscriptionData.clientSecret,
                appearance: {
                    theme: 'stripe',
                    variables: {
                        fontFamily: 'Spartan, sans-serif',
                        fontSizeBase: '12px',
                        colorText: 'rgb(39, 59, 100)',
                        colorPrimary: 'rgb(0, 160, 127)',
                    },
                },
            });
            this.paymentElement = this.elements.create('payment', {
                fields: {
                    billingDetails: {
                        address: {
                            country: 'never',
                        },
                    },
                },
            });
            this.paymentElement.mount(this.$refs.paymentElement);
            const linkAuthenticationElement = elements.create('linkAuthentication');
            linkAuthenticationElement.mount('#link-authentication-element');
        },
        onSirenInput(searchTerm) {
            if (this.fData.entity_siren && this.fData.entity_siren.length > 8) {
                this.sirenResults = new Promise(resolve => {
                    window.setTimeout(() => {
                        if (!searchTerm) {
                            resolve(this.sirenResults);
                        } else {
                            const term = searchTerm.replace(/\s/g, '');
                            axios.get(`/api/insee/siret?siren=${term}`).then((response) => {
                                //console.log(response);
                                if (!!response.data) {
                                    resolve(response.data.etablissements.filter((e) => e.periodesEtablissement[0].etatAdministratifEtablissement == 'A'));
                                }
                            }).catch((error) => {
                                console.log(error);
                                resolve(this.sirenResults);
                            });
                        }
                    }, 500);
                });
            }
        },
        onSirenSelected(value) {
            this.$nextTick(() => {
                this.fData.entity_name = value.uniteLegale.denominationUniteLegale;
                this.fData.entity_siren = value.siren;
                this.fData.entity_address = value.adresseEtablissement.numeroVoieEtablissement + ' ' + value.adresseEtablissement.typeVoieEtablissement + ' ' + value.adresseEtablissement.libelleVoieEtablissement;
                this.fData.entity_postcode = value.adresseEtablissement.codePostalEtablissement;
                this.fData.entity_city = value.adresseEtablissement.libelleCommuneEtablissement;
                this.fData.ape_code = value.uniteLegale.activitePrincipaleUniteLegale;
            });
        },
        onSirenNameInput(searchTerm) {
            if (this.fData.entity_name && this.fData.entity_name.length > 2) {
                this.sirenNameResults = new Promise(resolve => {
                    window.setTimeout(() => {
                        if (!searchTerm) {
                            resolve(this.sirenNameResults);
                        } else {
                            axios.get(`/api/insee/name?name=${searchTerm}`).then((response) => {
                                console.log(response.data);
                                if (!!response.data) {
                                    resolve(response.data.etablissements.filter((e) => e.periodesEtablissement[0].etatAdministratifEtablissement == 'A'));
                                }
                            }).catch((error) => {
                                console.log(error);
                                resolve(this.sirenNameResults);
                            });
                        }
                    }, 500);
                });
            }
        },
    }
};
</script>
<style lang="scss">

.sms-dialog {
    max-width: 300px;
    padding: 20px;
    min-height: 200px;
    .form-row {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        .code-field {
            display: flex;
            flex-direction: column;
            height: auto;
            .SMS__Code {
                display: flex;
                margin-bottom: 20px;
                input {
                    width: 40px;
                    height: 50px;
                    margin: 0px 10px;
                    border-radius: 6px;
                    border: none;
                    background: #E4E4E4;
                    text-align: center;
                }:focus {
                    outline: none;
                }
            }
            .md-helper-text, .md-error {
                width: 100%;
                display: block !important;
                justify-content: space-between;
                a {
                    display:block;
                    font-weight: bold;
                    text-decoration: underline;
                }
            }
            @media (max-width: 1100px) {
                margin-bottom: 40px;
                .md-helper-text, .md-error {
                    flex-direction: column;
                }
            }
        }
        .code-field::after {
            background: none;
        }
    }
}
.validate-contract {
    .contract-price-info {
        .contract-price-name {
            color: #00A07F;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 15px;
            strong {
                color: #273B64;
                margin-right: 15px;
            }

            .contract-price-free {
                font-size: 16px;
            }
        }
        .contract-price-amount {
            font-size: 20px;
            color: #00A07F;
            font-weight: bold;
            margin-bottom: 15px;
            position: relative;
            .promoPrice {
                font-weight: 400;
                font-size: 14px;
                text-decoration: line-through;
            }
        }
        .contract-price-promo-code {
            display: flex;
            align-items: center;
            .text {
                font-weight: bold;
                font-size: 12px;
                white-space: nowrap;
                padding-top: 4px;
                flex-grow: 1;
                text-align: right;
            }
            .input {
                margin-left: 10px;
                input {
                    max-width: 100px;
                    border-radius: 3px;
                    background: #E4E4E4;
                    border: none;
                    line-height: 24px;
                    text-align: center;
                    padding: 2px;
                } :focus {
                    outline: none;
                }
            }

            .valid {
                background: #00A07F;
                border-radius: 3px;
                line-height: 24px;
                text-align: center;
                border-radius: 3px;
                color: white;
                padding: 0px 4px 0px 10px;
                font-size: 14px;
                font-weight: bold;
                text-transform: uppercase;
                display: flex;
                i {
                    margin-left: 4px;
                    font-size: 20px !important;
                    font-weight: bold;
                    color: white;
                }
                span {
                    padding-top: 4px;
                }
            }
            .button {
                margin-left: 10px;
                button {
                    background: #00A07F;
                    height: 28px;
                    border-radius: 3px;
                    border: none;
                    padding: 0;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    font-size: 12px;
                    padding: 0 6px;
                    color: white;
                }:disabled {
                    background: #E4E4E4;
                }
            }
        }
    }
    .contract-iframe {
        min-height: 800px;
        width: 100%;
    }
    .contract-link {
        text-align: center;
    }

    label {
        color: #273B64 !important;
    }
    .md-error {
        display: block;
        color: var(--md-theme-default-fieldvariant, #ff1744);
        font-size: 12px;
    }
    .registration-form, .contract-price-info {
        .form-row {
            margin-top: 5px;
        }
    }
}
.select-institution-modal {
    width: 600px;
}
.md-datepicker {
    width: 100% !important;
}
.payment-confirmation-dialog {
    width: 1000px;
    max-width: 100vw;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ValidateContract.vue